import React, { useEffect, useRef } from 'react';
import { View, StyleSheet, Animated, Easing } from 'react-native';
import { AnimatedCircularProgress } from 'react-native-circular-progress';
import DoughnutWrapper from './DoughnutWrapper';

const PROGRESS_WIDTH = 6;
const TRACK_WIDTH = 2;
const ANIMATION_DURATION = 2200;
// Plus cette valeur est petite, plus la rotation des pointillés est lente
// -360 = 1 tour complet, -90 = 1/4 de tour.
const DASH_ROTATION_INTENSITY = '-90deg'; 

const Doughnut = ({ size, color, max = 1, current = 1, children, ...props }) => {
  const animatedFill = useRef(new Animated.Value(0)).current;

  const getFillPercent = () => {
    if (!max || max === 0) return 0;
    if (max === 'UNL') return 100;
    const maxVal = parseInt(max, 10);
    const percent = 100 - ((maxVal - current) / maxVal) * 100;
    return Math.min(100, Math.max(0, percent));
  };

  useEffect(() => {
    Animated.timing(animatedFill, {
      toValue: getFillPercent(),
      duration: ANIMATION_DURATION,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: false, 
    }).start();
  }, [current, max]);

  // INTERPOLATION RALENTIE POUR LA ROTATION DES POINTILLÉS
  const rotateData = animatedFill.interpolate({
    inputRange: [0, 100],
    outputRange: ['0deg', DASH_ROTATION_INTENSITY],
  });

  const innerSize = size - (PROGRESS_WIDTH * 2.5);

  return (
    <View {...props} style={[styles.outerContainer, { width: size, height: size }, props.style]}>
      
      {/* COUCHE DE FOND : Pointillés avec rotation ralentie */}
      <Animated.View 
        style={[
          StyleSheet.absoluteFill, 
          { 
            transform: [{ rotate: rotateData }], 
            justifyContent: 'center', 
            alignItems: 'center' 
          }
        ]}
      >
        <AnimatedCircularProgress
          size={size}
          fill={100}
          tintColor="transparent"
          backgroundColor="#E0E0E0"
          backgroundWidth={TRACK_WIDTH}
          width={TRACK_WIDTH}
          rotation={0}
          padding={0}
          dashedBackground={{ width: 8, gap: 6 }}
        />
      </Animated.View>

      {/* COUCHE DE PROGRESSION : Couleur principale */}
      <AnimatedCircularProgress
        size={size}
        fill={getFillPercent()}
        tintColor={color || "#0000FF"}
        backgroundColor="transparent"
        width={PROGRESS_WIDTH}
        rotation={0}
        duration={ANIMATION_DURATION}
        lineCap="round"
        padding={0}
      >
        {() => (
          <DoughnutWrapper size={innerSize}>
            {children}
          </DoughnutWrapper>
        )}
      </AnimatedCircularProgress>
    </View>
  );
};

const styles = StyleSheet.create({
  outerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 5,
    backgroundColor: 'transparent',
  },
});

export default Doughnut;